<template>
  <span :class="['value', colorClass]">{{ value }}</span>
</template>

<script>
export default {
  name: "StrategyReportValue",
  props: {
    value: {
      type: Number,
      default: 0,
    },
    breakpoint: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    colorClass() {
      return this.value > this.breakpoint ? 'teal--text text--darken-2' : 'red--text text--accent-4';
    }
  },
}
</script>

<style scoped>
.value {
  font-weight: bold;
}
</style>